import { useMemo } from "react";
import { defineMessages } from "react-intl";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { EVENTS } from "../SchemaTypes";
import Field from "../Field";
import CheckBoxesInput from "../../Input/CheckBoxesInput";
import SelectInput from "../../Input/SelectInput";
import { useFormatMessage } from "../../Intl/Context";

const EVENTS_FIELD_VALUE_NONE = "none";

const EventsField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, allowNone, maximumEvents, none } = props;

  const t = useFormatMessage();
  const tooLongMessage = t(intlMessages.tooLongMessage, {
    count: maximumEvents
  });
  const noneOptionLabel = t(intlMessages.noneOption);

  const multiEvents = maximumEvents > 1;

  const defaultValues = none
    ? [...props.defaultValues, EVENTS_FIELD_VALUE_NONE]
    : props.defaultValues;

  const options = useMemo(() => {
    const optionsWithNone = allowNone
      ? [...props.options, { id: EVENTS_FIELD_VALUE_NONE, name: noneOptionLabel }]
      : props.options;

    if (multiEvents) return optionsWithNone;

    return optionsWithNone.map(({ id: value, name: label }) => ({ value, label }));
  }, [allowNone, multiEvents, noneOptionLabel, props.options]);

  const schema = {
    type: EVENTS,
    parent,
    validations: {
      required,
      length: multiEvents && { maximum: maximumEvents, tooLongMessage }
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      {multiEvents ? (
        <CheckBoxesInput
          {...inputProps}
          defaultValues={defaultValues}
          options={options}
          maxSelectedOptions={maximumEvents}
        />
      ) : (
        <SelectInput
          {...inputProps}
          options={options}
          maxSelectedOptions={maximumEvents}
          defaultValue={{ value: defaultValues[0] }}
        />
      )}
    </Field>
  );
};

export default EventsField;

const intlMessages = defineMessages({
  tooLongMessage: {
    id: "answers.events.error.tooLongMessage",
    defaultMessage: "Merci de sélectionner au maximum {count} évènement(s)."
  },
  noneOption: {
    id: "answers.events.noneOption",
    defaultMessage: "Aucun"
  }
});
